<template>
  <v-container fluid grid-list-md fill-height style="padding:0px 10px 5px 10px;width:100%;height:100%;">
    <v-layout row>
      <v-flex d-flex md6>
        <v-card>
          <v-card-title primary class="title" style="height:5%;width:100%;padding-top:5px;padding-bottom:5px;">Subsystem KPIs</v-card-title>
          <v-card-actions fill-height style="height:95%;width:100%;padding-top:0px;padding-bottom:0px;">
            <dx-data-grid
                class="grid"
                :data-source="sysKpiGrid"
                :show-column-lines="true"
                :show-row-lines="true"
                :show-borders="true"
                :word-wrap-enabled="true"
                :row-alternation-enabled="false"
                :column-auto-width="true"
                @cellClick="gridClick"
                @cellPrepared="cellPrepared">
              <dx-column data-field="engType" caption=""/>
              <dx-column v-for="sys in subSystems" :key="sys" :data-field="sys.tag" :caption="sys.name" format="percent"/>
              <dx-sorting mode="none"/>
            </dx-data-grid>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex d-flex md6>
        <v-layout column>
          <v-flex d-flex md6 style="max-height:50%;">
            <v-card fill-height :flat="flat" style="height:100%;width:100%;">
              <v-card-title primary class="title" style="height:15%;width:100%;padding-top:5px;padding-bottom:5px;">Most Frequent Issues</v-card-title>
              <v-card-actions fill-height style="height:85%;width:100%;padding-top:0px;padding-bottom:0px;">
                <v-layout row fill-height>
                  <v-flex d-flex v-for="sys in subSystems" :key="sys" :style='"max-width:"+(100/subSystems.length)+"%;"'>
                    <Chart v-if="chartData[sys.tag]" v-bind:chartOptions="chartData[sys.tag]" v-bind:title="sys.name" v-bind:active="active" v-bind:flat="true"/>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-flex>
          <v-flex d-flex md6 style="max-height:50%;">
            <Chart v-if="chartData['issues']" v-bind:chartOptions="chartData['issues']" v-bind:title="'Issues / Subsystem'" v-bind:active="active"/>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Chart from '../components/Chart'
import {DxDataGrid, DxColumn, DxPaging, DxScrolling, DxSorting} from 'devextreme-vue/data-grid';

export default {
  name: "SubsystemsOverview",
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxScrolling,
    DxSorting,
    Chart
  },
  data() {
    return {
      chartData: {},
      subSystems: [
        {
          name: 'Servo Oil',
          tag: 'so'
        },
        {
          name: 'Fuel Injection',
          tag: 'fi'
        },
        {
          name: 'Scavenge Air',
          tag: 'sac'
        },
        {
          name: 'Exhaust Gas',
          tag: 'egs'
        },
        {
          name: 'Piston Running',
          tag: 'pr'
        },
        {
          name: 'Gas Admission',
          tag: 'gas'
        }],
      sysKpiGrid: [],
    }
  },
  props: {
    active: Boolean,
    subSysData: Object
  },
  computed: {},
  created() {
  },
  mounted() {
    setTimeout(() => {
      this.setData();
    });
  },
  methods: {
    gridClick(e) {
      if (e.rowType == "header") {
        this.$router.push({'path': `/subsystems/${e.column.caption}`});
      }
    },
    cellPrepared(e) {
      if (e.rowType == "header") {
        e.cellElement.classList.add('clickable');
      }
    },
    setData() {
      this.$set(this.chartData, 'issues', {
        credits: false,
        chart: {
          height: 0,
          zoomType: 'xy'
        },
        legend: {
          enabled: false
        },
        xAxis: {
          categories: this.subSystems.map(function (item) {
            return item.name;
          }),
          crosshair: true
        },
        yAxis: {
          title: {
            text: undefined
          }
        },
        exporting: {
          enabled: false
        },
        title: {
          text: undefined
        },
        series: [{
          type: 'column',
          animation: false,
          data: [],
          states: {
            hover: {
              enabled: false
            },
            normal: {
              animation: false
            },
            inactive: {
              opacity: 1
            }
          }
        }],
        tooltip: {
          formatter: function () {
            return 'Engine ' + this.x + ': ' + this.point.y.toFixed(1);
          }
        }
      });

      for (let i = 0; i < this.subSystems.length; i++) {
        if (!!!this.subSysData[this.subSystems[i].name]) {
          continue
        }
        this.chartData['issues'].series[0].data.push({
          y: this.subSysData[this.subSystems[i].name][this.subSystems[i].tag + 'FaultNo'],
          color: 'rgb(144,170,218)'
        });
      }

      let engineTypes = Object.keys(this.subSysData['Servo Oil'].engineTypes);

      this.sysKpiGrid = [];
      for (let i = 0; i < engineTypes.length; i++) {
        var temp = {'engType': engineTypes[i]};

        for (let j = 0; j < this.subSystems.length; j++) {
          if (Object.keys(this.subSysData[this.subSystems[j].name].engineTypes).includes(engineTypes[i])) {
            var kpi = this.subSysData[this.subSystems[j].name].engineTypes[engineTypes[i]][this.subSystems[j].tag + '_KPI'];

            kpi = ((kpi != -1000) ? kpi : '-');
            temp[this.subSystems[j].tag] = kpi;
          }
        }

        this.sysKpiGrid.push(temp);
      }

      for (let i = 0; i < this.subSystems.length; i++) {
        this.$set(this.chartData, this.subSystems[i].tag, {
          credits: false,
          chart: {
            height: 0,
          },
          legend: {
            enabled: false
          },
          exporting: {
            enabled: false
          },
          title: {
            text: undefined
          },
          plotOptions: {
            pie: {
              shadow: false,
              center: ['50%', '50%'],
              dataLabels: {
                enabled: false
              },
            }
          },
          series: [{
            type: 'pie',
            animation: false,
            data: [],
            size: '100%',
            innerSize: '70%',
            states: {
              hover: {
                enabled: false
              },
              normal: {
                animation: false
              },
              inactive: {
                opacity: 1
              }
            }
          }],
          tooltip: {
            formatter: function () {
              return this.point.name + ': ' + this.point.y.toFixed(1);
            }
          },
        });

        let topFaults = this.subSysData[this.subSystems[i].name].topFaults;

        for (let j = 0; j < topFaults.length; j++) {

          this.chartData[this.subSystems[i].tag].series[0].data.push({
            y: Number(topFaults[j].percentage),
            name: topFaults[j].description
          });
        }
      }
    }
  },
  watch: {
    subSysData: function () {
      setTimeout(() => {
        this.setData();
      });
    }
  }
}
</script>

<style scoped>

</style>
